/* globals AddNewFloatingDiv */

// Todo: Remove this abomination.
var nJ           = require('../../../../js_functions/form-builder/js/not-jquery');
var Translation  = require('../../../../js_functions/medsEquipmentsTranslation');
var translations = new Translation('devices');

function noMatchesFoundContent(invalidLocation) {

  var noMatches = document.createElement('div'),
      noMatchesDescription = document.createElement('div'),
      noMatchesHelper = document.createElement('span');

  nJ.addClass(noMatches, 'no-matches');

  noMatchesDescription.textContent = translations.translateString('DEVICES.V2.FORM.MESSAGE.DEVICE_SEARCH.NO_MATCHES');
  nJ.addClass(noMatchesDescription, 'description');
  noMatches.appendChild(noMatchesDescription);

  noMatchesHelper.textContent = translations.translateString(
    invalidLocation ? 'EQUIPMENT.V2.FORM.MESSAGE.EQUIPMENT_SEARCH.INVALID_LOCATION' : 'DEVICES.V2.FORM.MESSAGE.DEVICE_SEARCH.EXACT_MATCHES_ONLY'
  );

  nJ.addClass(noMatchesHelper, 'helper-text');
  noMatches.appendChild(noMatchesHelper);

  return noMatches;

}


function generateTable(data) {

  var headers = [
        { name: translations.translateString('DEVICES.V2.FORM.MESSAGE.DEVICE_SEARCH.MATCHING_EQUIPMENT'), dataId: 'genericName' },
        { name: translations.translateString('DEVICES.V2.MESSAGE.SEARCH_TABLE.TYPE'), dataId: 'type' },
        { name: translations.translateString('DEVICES.V2.MESSAGE.SEARCH_TABLE.SUB_TYPE'), dataId: 'subType' },
        { name: translations.translateString('DEVICES.V2.MESSAGE.SEARCH_TABLE.BRAND'), dataId: 'brand' },
        { name: translations.translateString('DEVICES.V2.MESSAGE.SEARCH_TABLE.MANUFACTURER'), dataId: 'manufacturer' }
      ],
      table = document.createElement('table'),
      columnCount = headers.length;

  const tableClasses = [
    'table',
    'table-striped',
    'table-hover',
    'no-bottom-margin'
  ];

  if(globals && globals.isRightToLeft) {
    tableClasses.push('dtx-table-rtl');
  }

  nJ.addClass(table, tableClasses);

  var row = table.insertRow(-1);
  for (var i = 0; i <= columnCount; i++) {
    var headerCell = document.createElement('th');
    headerCell.innerHTML = headers[i] ? headers[i]['name'] : '';
    nJ.addClass(headerCell, ['matchingResult__table-header']);
    row.appendChild(headerCell);
  }

  //Add the data rows.
  Object.keys(data).forEach(function (key) {
    row = table.insertRow(-1);
    for (var j = 0; j < columnCount; j++) {
      var cell = row.insertCell(-1);

      cell.innerHTML = data[key][headers[j]['dataId']];

      if (j === columnCount - 1) {
        cell = row.insertCell(-1);
        var choseBtn = document.createElement('button');
        choseBtn.textContent = translations.translateString('DEVICES.V2.BUTTON.SEARCH_TABLE.CHOOSE');
        nJ.addClass(choseBtn, 'matchingResult__button');

        choseBtn.addEventListener('click', function () {
          var chooseEvent = new CustomEvent('onEquipmentDrugChoseEvent', {
            detail: {
              equipment:data[key],
              value:data[key]['brand']
            },
            bubbles: true,
            cancelable: false
          });

          this.dispatchEvent(chooseEvent);
        });
        cell.appendChild(choseBtn);
      }
    }
  });

  return table;
}


function showSearchResultsDialog(data, equipmentAPIService) {
  var title = translations.translateString('DEVICES.V2.FORM.MESSAGE.DEVICE_SEARCH.MATCHING_EQUIPMENT'),
      modal = AddNewFloatingDiv('matching-equipment'),
      dataLength = 0,
      invalidLocation = false;

  if (typeof data === 'object' && data !== null) {
    if (data.invalidLocation) {
      invalidLocation = true;
    } else {
      dataLength = Object.keys(data).length;
    }
  }

  modal.setTitle(title);
  if (dataLength > 0) {
    modal.setContents(generateTable(data));
    if (equipmentAPIService.APIVersion === 2) {
      setPaginationButtons(modal, equipmentAPIService);
    }
  }
  else {
    modal.setContents(noMatchesFoundContent(invalidLocation));
  }

  var modalHeight = (dataLength > 10) ? 500 : null;
  modal.setSizeModify({ width: null, height: modalHeight });
  modal.display();

  return modal;
}

function setPaginationButtons(modal, equipmentAPIService) {
  const buttons = [
    {
      value: translations.translateString('COMMON.PREVIOUS'),
    },
    {
      value: translations.translateString('COMMON.NEXT'),
    },
  ];

  if (equipmentAPIService.hasPreviousPage()) {
    buttons[0].class = 'button-primary';

    buttons[0].onclick = function() {
      equipmentAPIService.previousPage()
        .then(function(response) {
          modal.setContents(generateTable(response));
          setPaginationButtons(modal, equipmentAPIService);
        });
    }
  }
  if (equipmentAPIService.hasNextPage()) {
    buttons[1].class = 'button-primary';

    buttons[1].onclick = function() {
      equipmentAPIService.nextPage()
        .then(function(response) {
          modal.setContents(generateTable(response));
          setPaginationButtons(modal, equipmentAPIService);
        });
    };
  }

  modal.setButtons(buttons);
}

function generateModal(equipmentBrands, equipmentAPIService) {
  return new Promise(function (resolve) {
    translations
      .getTranslations()
      .then(function () {
        window.hideLoadPopup();
        resolve(showSearchResultsDialog(equipmentBrands, equipmentAPIService));
      });
  });
}

module.exports = generateModal;
